export const ACTIVITY_KEY = 'lastactivetime'
export const LAST_API_KEY = 'lastapitime'
export const REDIRECT_KEY = 'redirectTo'
export const SECURITY_NOTIFICATION_FLAG_KEY = 'security_notifcation'
